import _extends from "@babel/runtime/helpers/extends";
/**
 * This file generated by Stencil generateIcons scripts
 * DO NOT EDIT DIRECTLY
 */

import React from 'react';
import { withIconProps } from '../utils/withIconProps';
import { jsx as ___EmotionJSX } from "@emotion/react";
const IconCheckCircleFillSmall = withIconProps(props => {
  return ___EmotionJSX("svg", _extends({
    width: "20px",
    height: "20px",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ___EmotionJSX("path", {
    d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM15.5365 8.28027C16.2436 7.43172 16.1289 6.17059 15.2804 5.46346C14.4318 4.75633 13.1707 4.87098 12.4636 5.71953L8.9785 9.90162L7.51853 8.19832C6.79969 7.35967 5.53709 7.26255 4.69844 7.98139C3.85978 8.70023 3.76266 9.96283 4.48151 10.8015L7.4815 14.3015C7.86463 14.7485 8.42522 15.0039 9.0139 14.9999C9.6026 14.9958 10.1596 14.7325 10.5365 14.2803L15.5365 8.28027Z",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "currentColor"
  }));
}, 'IconCheckCircleFillSmall');
IconCheckCircleFillSmall.displayName = 'IconCheckCircleFillSmall';
export default IconCheckCircleFillSmall;